import nedarimProtocol from "./nedarim"

/**
 * Registre des protocoles iframe par plateforme (dispatcher front).
 * Transpose le pattern adapter+dispatcher du backend : une plateforme de paiement
 * embarquée = une clé ici. Pour en ajouter une, créer un descripteur dans ce dossier
 * et l'enregistrer ci-dessous.
 */
const PROTOCOLS = {
    NEDARIM: nedarimProtocol,
}

export function getIframeProtocol(platform) {
    return PROTOCOLS[platform] || null
}

export default PROTOCOLS
